import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { Text } from '../text'

export type WeekdayLabelProps = {
    /** Short weekday abbreviation to display, e.g. `Mo`. */
    label: string
    className?: string
}

const container = 'size-6 items-center justify-center'

/**
 * Column header cell for a calendar grid (e.g. `Mo`). 24×24, centred,
 * Manrope P3 13/20. Presentational — pair with {@link DayCell} inside
 * {@link CalendarSheet}.
 */
export const WeekdayLabel: React.FC<WeekdayLabelProps> = ({ label, className }) => (
    <Box className={twMerge(container, className)}>
        <Text size='P3' weight='medium' tone='default'>
            {label}
        </Text>
    </Box>
)

WeekdayLabel.displayName = 'WeekdayLabel'
